import { render, staticRenderFns } from "./wuju-quote.vue?vue&type=template&id=20db3244&scoped=true&"
import script from "./wuju-quote.vue?vue&type=script&lang=js&"
export * from "./wuju-quote.vue?vue&type=script&lang=js&"
import style0 from "./wuju-quote.vue?vue&type=style&index=0&id=20db3244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20db3244",
  null
  
)

export default component.exports